import React from "react";
import PropTypes from "prop-types";

const NewLabel = props => {
  const uid = Math.random()
    .toString(36)
    .substr(2, 9);

  return (
    <svg width="26" height="16" xmlns="http://www.w3.org/2000/svg" className={props.className}>
      <defs>
        <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id={uid}>
          <stop stopColor="#FF3274" offset="0%" />
          <stop stopColor="#991EE3" offset="100%" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <rect fill={`url(#${uid})`} x="1" y="2" width="24" height="12" rx="2" />
        <path
          d="M8.02 5l-.025.138-.6 3.344-1.016-3.366L6.343 5H5.075l-.025.138-1.012 5.652L4 11h1.23l.024-.139.612-3.417 1.054 3.44.035.116h1.22l.025-.139 1.012-5.65L9.25 5zm2.388 0l-.026.138L9.29 10.79l-.04.21h4.217l.027-.139.194-1.015.041-.21h-2.844l.212-1.105h2.495l.027-.138.191-.981.041-.211h-2.495l.163-.85h2.717l.028-.138.194-1.002L14.5 5zm10.185 0l-.04.105-1.282 3.27-.004.007.017-3.206.001-.176h-1.357l-.04.109-1.163 3.224-.05-3.162L16.673 5H15.25l.012.188.354 5.65.011.162h1.214l.039-.107 1.222-3.305.058-.167-.002.095-.018 3.309V11h1.245l.042-.097 2.464-5.65.109-.251V5h-1.407zm1.16.175l-2.464 5.65 2.464-5.65zm-2.64 3.236l.017-3.236-.016 3.236-.017.9.017-.9zm-1.154-.89l.38-1.093-.38 1.093-1.22 3.305h-.001l1.221-3.305zm-1.387.89l-.027.9.027-.9z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
};

NewLabel.propTypes = {
  className: PropTypes.string
};

export default NewLabel;
